const unspecified = {
  rate: 0.0,
  amount: 0.0,
  object: {},
  type: '',
};

const type = {
  CASH: 'CASH',
  FINANCE: 'FINANCE',
  LEASE: 'LEASE',
};

const province = {
  AB: 'AB',
  BC: 'BC',
  MB: 'MB',
  NB: 'NB',
  NL: 'NL',
  NT: 'NT',
  NS: 'NS',
  NU: 'NU',
  ON: 'ON',
  PE: 'PE',
  QC: 'QC',
  SK: 'SK',
  YT: 'YT',
};

const termUnit = {
  year: 'YEAR',
  month: 'MONTH',
};

const compoundInterestFrequency = {
  YEAR: 'year',
  MONTH: 'month',
  DAY: 'day',
};

module.exports = {
  UNSET: unspecified,
  PROV: province,
  OPTS: type,
  COMPOUND: compoundInterestFrequency,
  UNIT: termUnit,
};
